export default function EmbedCTA({ cta, style, wrapperClass }) {
  wrapperClass = wrapperClass ? wrapperClass : "flex-row-center";

  return (
    <div
      className={wrapperClass}
      style={{ marginTop: "30px", marginBottom: "60px", ...style }}
    >
      <div dangerouslySetInnerHTML={{ __html: cta.embedCode }} />
    </div>
  );
}
